import { __read } from "tslib";
import { useStandaloneCopilotApp } from '@office-start/copilot-route-service';
import { useIdentity } from '@office-start/identity-service';
import { runBeforeLayout } from '@office-start/performance-utility';
import { IDLE_HIGH_PRIORITY, IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import { useEffect, useMemo, useRef, useState } from 'react';
export function useShouldInitializeFolders() {
    var _a;
    var identity = useIdentity().data;
    var userEntitlements = useUserEntitlements().data;
    var _b = __read(useState(false), 2), shouldInitializeFolders = _b[0], setShouldInitializeFolders = _b[1];
    var workHandle = useRef(null);
    var isStandaloneCopilotApp = useStandaloneCopilotApp();
    var hasCachedPodId = useMemo(function () {
        return !!((identity === null || identity === void 0 ? void 0 : identity.puid) &&
            localStorage.getItem("defaultPod_".concat(identity.puid)));
    }, [identity]);
    var priority = useMemo(function () { return (hasCachedPodId ? IDLE_HIGH_PRIORITY : IDLE_VERYLOW_PRIORITY); }, [hasCachedPodId]);
    useEffect(function () {
        var _a;
        if (!identity || !((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.OneDriveResourceId)) {
            return;
        }
        workHandle.current = scheduleWork(function () {
            return runBeforeLayout(function () {
                setShouldInitializeFolders(true);
            });
        }, priority);
        return function () {
            var _a;
            (_a = workHandle.current) === null || _a === void 0 ? void 0 : _a.cancel();
        };
    }, [identity, priority, (_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.OneDriveResourceId]);
    return isStandaloneCopilotApp ? false : shouldInitializeFolders;
}
//# sourceMappingURL=useShouldInitializeFolders.js.map